import Marionette from 'backbone.marionette';
import membersBrowseTmpl from '../templates/members_browse_layout.tpl';
export default Marionette.LayoutView.extend({
  template: membersBrowseTmpl,
  regions: {
    membersFiltersRegion: "#members-filters-region",
    membersRegion: "#members-region"
  }
});